import { useEffect } from 'react';
import * as api from '../../../services/oldApiService';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const VerifyAccountPage = () => {

  const navigate = useNavigate();
  const { user, login } = useAuth();

  const { token = '' } = useParams();

  useEffect(() => {
    if (!token) return;

    const verify = async () => {
      const { data, status_code: statusCode } = await api.verifyAccount({
        token: decodeURIComponent(token),
      });

      if (statusCode === api.status.SUCCESS) {
        if (user) {
          const updatedUser = { ...user, verified: true };
          login(updatedUser);
        }
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/signin', { replace: true });
      }
    };

    verify();
  }, [token]);

  return <div></div>;
};

export default VerifyAccountPage;
